export default __webpack_public_path__ + "static/socialmindr-bg-video-568c118e7a8156ab437b31cc6caacc69.mp4";